import React from 'react';
import Reveal from './Reveal';

const SectionHeading = ({ eyebrow, title, subtitle }) => (
    <Reveal className="mb-12 max-w-[720px]">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#64ffda] mb-3">{eyebrow}</p>
        <h2 className="text-3xl sm:text-4xl font-bold text-slate-50 tracking-tight">{title}</h2>
        {subtitle && <p className="mt-4 text-slate-400 text-base sm:text-lg">{subtitle}</p>}
    </Reveal>
);

export default SectionHeading;
